import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { 
  REQUEST, 
  createModelSuccess, 
  createModelFailure 
} from '../../actions/models/create';
import { fetchRequest as fetchModels } from '../../actions/models/list';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';
import { Error as ErrorAction } from '../../actions/error/error';

// Worker saga for creating a model
function* createModel(action) {
  try {
    const response = yield call(axios.post, 
      `${config.API_URL}/pipelines`,
      action.payload,
      { headers: getLocalUser() }
    );
    
    // Dispatch success action with the response data
    yield put(createModelSuccess(response.data));
    
    // Add success snackbar message
    yield put({ type: 'SHOW_SUCCESS_SNACKBAR', message: 'Pipeline created successfully' });
    
    // Refresh the models list after successful creation
    yield put(fetchModels({}));
    
    // Return success data for components to use
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Create model saga error:', error);

    const errorMessage = extractErrorMessage(error);

    // Dispatch global error action
    yield put(ErrorAction(error));
    
    // Dispatch failure action with the error
    yield put(createModelFailure(errorMessage));
    
    // Return error data for components to use
    return {
      success: false,
      error: errorMessage
    };
  }
}

// Watcher saga for model creation
export function* watch() {
  yield takeLatest(REQUEST, createModel);
} 